import { Injectable } from '@angular/core';
import { FoxitConfigService } from 'webcommon/lazy-load-commonjs/foxit';
import { ApBaseClass, EventComposite, FoxitLicenseDto, SystemGuid } from 'webcommon/shared';
import { FoxitLicenseRepository } from 'webcommon/webapi';

@Injectable({
  providedIn: 'root',
})
export class FoxitConfigService2 extends ApBaseClass implements FoxitConfigService {
  readonly foxitLicense$ = EventComposite.create<FoxitLicenseDto>(this).setupAndStart(
    null,
    () => this.foxitLicenseRepository.getFoxitLicense(
      SystemGuid.ProductParameterFoxitLicenseSN,
      SystemGuid.ProductParameterFoxitLicenseKey,
      SystemGuid.ProductParameterFoxitDefaultTool,
      SystemGuid.ProductParameterFoxitDefaultViewMode,
    ),
  );

  constructor(
    private foxitLicenseRepository: FoxitLicenseRepository,
  ) {
    super();
  }

  getFoxitLicense(): Promise<FoxitLicenseDto> {
    return this.foxitLicense$.getAfterLoadP();
  }
}
